import { useEffect, useState } from 'react';

/** Menos que isso não filtra (um código ou uma palavra curta casaria com quase tudo). */
export const MINIMO_DA_BUSCA = 3;
/** Espera depois da última tecla, para não disparar uma consulta por letra. */
const ESPERA_DA_BUSCA_MS = 400;

export const TAMANHO_INICIAL_DA_PAGINA = 25;
export const TAMANHOS_DE_PAGINA = [TAMANHO_INICIAL_DA_PAGINA, 50, 100];

export const ROTULOS_DA_PAGINACAO = {
  first: 'Primeira página',
  last: 'Última página',
  next: 'Próxima página',
  previous: 'Página anterior',
} as const;

export interface BuscaPaginada {
  /** O que está no campo, a cada tecla. */
  readonly digitado: string;
  readonly definirDigitado: (texto: string) => void;
  /** O que vai para a API: só depois da pausa e com 3+ letras (senão, vazio). */
  readonly busca: string;
  /** Aviso para o campo enquanto há 1 ou 2 letras. */
  readonly aviso: string | undefined;
  /** Começa em 0 (como o `TablePagination`); a API conta a partir de 1. */
  readonly pagina: number;
  readonly definirPagina: (pagina: number) => void;
  readonly tamanho: number;
  readonly definirTamanho: (tamanho: number) => void;
  /** Para chamar quando um filtro que não é a busca muda (competência, contrato). */
  readonly voltarParaPrimeiraPagina: () => void;
}

/**
 * A busca e a paginação de uma tabela: o texto só vira consulta com 3+ letras e 0,4 s depois da
 * última tecla (sem uma consulta por letra), e a busca nova volta à primeira página.
 */
export function useBuscaPaginada(): BuscaPaginada {
  const [digitado, definirDigitado] = useState('');
  const [busca, definirBusca] = useState('');
  const [pagina, definirPagina] = useState(0);
  const [tamanho, definirTamanho] = useState(TAMANHO_INICIAL_DA_PAGINA);

  useEffect(() => {
    const termo = digitado.trim();
    const aplicado = termo.length >= MINIMO_DA_BUSCA ? termo : '';
    // Só volta à página 1 quando a busca APLICADA muda. Sem isto o efeito rodava na montagem (e a cada letra abaixo
    // do mínimo) e, 400 ms depois, jogava para a página 1 quem tivesse acabado de clicar em "Próxima página".
    if (aplicado === busca) {
      return undefined;
    }
    const espera = setTimeout(() => {
      definirBusca(aplicado);
      definirPagina(0);
    }, ESPERA_DA_BUSCA_MS);
    return () => {
      clearTimeout(espera);
    };
  }, [digitado, busca]);

  const tamanhoDoTermo = digitado.trim().length;
  const aviso =
    tamanhoDoTermo > 0 && tamanhoDoTermo < MINIMO_DA_BUSCA ? `Digite ao menos ${String(MINIMO_DA_BUSCA)} letras` : undefined;

  return {
    digitado,
    definirDigitado,
    busca,
    aviso,
    pagina,
    definirPagina,
    tamanho,
    definirTamanho,
    voltarParaPrimeiraPagina: () => {
      definirPagina(0);
    },
  };
}
